import { dashboardApi } from "services/config/axiosConfig";

const config = (token: any) => {
  return {
    headers: {
      Authorization: `Bearer ` + token,
    },
  };
};

export const getAllJobPoster = async (search?: Record<string, string>) => {
  let url = "/api/v1/school/job";

  if (search) {
    const queryParams = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
      if (value && String(value).trim()) {
        queryParams.append(key, String(value).trim());
      }
    });
    const qs = queryParams.toString();
    if (qs) url += `?${qs}`;
  }

  const response = await dashboardApi.get(url);
  return response.data;
};

export const getJobSubjects = async () => {
  const response = await dashboardApi.get("/api/v1/school/job/subjects");
  return response.data;
};

export const getFeaturedJobCheckout = async (token: string, jobId: string) => {
  const response = await dashboardApi.get(`/api/v1/payment/featured-job/${jobId}`, config(token));
  return response.data;
};

export const getRecommendedJobs = async (token: string) => {
  const response = await dashboardApi.get(`/api/v1/teacher/job/recommended`, config(token));
  return response.data;
};

export const getJobAlerts = async (token: string) => {
  const response = await dashboardApi.get(`/api/v1/teacher/job/alerts`, config(token));
  return response.data;
};

export const createJobAlert = async (token: string, alertData: Record<string, string>) => {
  const response = await dashboardApi.post(`/api/v1/teacher/job/alerts`, alertData, config(token));
  return response.data;
};

export const deleteJobAlert = async (token: string, alertId: string) => {
  const response = await dashboardApi.delete(`/api/v1/teacher/job/alerts/${alertId}`, config(token));
  return response.data;
};

export const updateTeacherProfile = async (token: string, profileData: Record<string, any>) => {
  const formData = new FormData();
  const allowEmpty = new Set(["default_cover_letter", "teaching_subject", "city"]);
  Object.entries(profileData).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value === "" && !allowEmpty.has(key)) return;
    formData.append(key, value);
  });
  const response = await dashboardApi.put(`/api/v1/core/profile/update`, formData, config(token));
  return response.data;
};

export const getJobByIdPoster = async (id: string, token: string) => {
  const response = await dashboardApi.get(`/api/v1/school/job/${id}`, config(token));
  return response.data;
};

export const getSimilarJobs = async (jobId: string, token?: string | null) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await dashboardApi.get(`/api/v1/school/job/similar/${jobId}`, { headers });
  return response.data;
};

export const addJobFn = async ({ jobData, token }: any) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(jobData)) {
    if (value !== undefined && value !== null) {
      if (typeof value === "object" && !(value instanceof Blob)) {
        // If the value is an object and not a Blob, convert it to a JSON string
        formData.append(key, JSON.stringify(value));
      } else {
        // Explicitly define the types for the value variable
        formData.append(key, value as string | Blob);
      }
    }
  }
  const response = await dashboardApi.post("/api/v1/school/job", formData, config(token));
  return response.data;
};

export const editJobFn = async ({ jobData, token, id }: any) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(jobData)) {
    if (value !== undefined && value !== null) {
      if (typeof value === "object" && !(value instanceof Blob)) {
        // If the value is an object and not a Blob, convert it to a JSON string
        formData.append(key, JSON.stringify(value));
      } else {
        // Explicitly define the types for the value variable
        formData.append(key, value as string | Blob);
      }
    }
  }
  const response = await dashboardApi.put(`/api/v1/school/job/${id}`, formData, config(token));
  return response.data;
};

export const getSchoolJobs = async (token: string, school_id: string) => {
  const response = await dashboardApi.get(`/api/v1/school/job?school_id=${school_id}`, config(token));
  return response.data;
};

export const deleteSchoolJob = async (token: string, id: string) => {
  const response = await dashboardApi.delete(`/api/v1/school/job/${id}`, config(token));
  return response.data;
};

export const addSavedJob = async (token: string, jobDetails: any) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(jobDetails)) {
    formData.append(key, value as string);
  }
  const response = await dashboardApi.post(`/api/v1/school/job/save`, formData, config(token));
  return response.data;
};

export const getSchools = async () => {
  const response = await dashboardApi.get(`/api/v1/school/`);
  return response.data;
};

export const applyOnJob = async (jobData: any, token: any) => {
  const { job_poster, use_profile_cv, ...rest } = jobData;
  const formData = new FormData();
  if (use_profile_cv) {
    formData.append("use_profile_cv", "true");
  }
  for (const [key, value] of Object.entries(rest)) {
    if (value !== undefined && value !== null) {
      if (typeof value === "object" && !(value instanceof Blob)) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value as string | Blob);
      }
    }
  }
  const response = await dashboardApi.post(`/api/v1/teacher/job/hire?job_id=${job_poster}`, formData, config(token));
  return response.data;
};

export const getStats = async (token: string, stats_id: string) => {
  const response = await dashboardApi.get(`/api/v1/stats/cards?stats_id=${stats_id}`, config(token));
  return response.data;
};

export const getMyApplications = async (token: string, teacher_id: string) => {
  const response = await dashboardApi.get(`/api/v1/teacher/job/hire?teacher_id=${teacher_id}`, config(token));
  return response.data;
};

export const deleteMyApplications = async (token: string, id: string) => {
  const response = await dashboardApi.delete(`/job-posting/user-applications/${id}/`, config(token));
  return response.data;
};

export const getSavedJobs = async (token: string) => {
  const response = await dashboardApi.get(`/api/v1/school/job/save`, config(token));
  return response.data;
};

export const getFavouriteJobs = async (token: string) => {
  const response = await dashboardApi.get(`/teacher/fav-jobs/`, config(token));
  return response.data;
};

export const getApplicantsForSchools = async (token: string, jobId: string) => {
  const response = await dashboardApi.get(`/api/v1/teacher/job/hire?job_id=${jobId}`, config(token));
  return response.data;
};

export const updateApplication = async (
  token: string,
  hireId: string,
  data: { status?: string; school_note?: string }
) => {
  const response = await dashboardApi.patch(`/api/v1/teacher/job/hire/${hireId}`, data, config(token));
  return response.data;
};

export const getUserProfile = async (token: string) => {
  const response = await dashboardApi.get(`/api/v1/core/profile`, config(token));
  return response.data;
};

const openCvUrl = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

export const openProfileCv = async (token: string) => {
  const response = await dashboardApi.get(`/api/v1/core/profile/cv?format=url`, config(token));
  const url = response.data?.data?.url;
  if (!url) {
    throw new Error("Could not load CV.");
  }
  openCvUrl(url);
};

export const openHireCv = async (token: string, hireId: string) => {
  const response = await dashboardApi.get(`/api/v1/teacher/job/hire/${hireId}/cv?format=url`, config(token));
  const url = response.data?.data?.url;
  if (!url) {
    throw new Error("Could not load CV.");
  }
  openCvUrl(url);
};

export const updateProfilePhoto = async (photo: any, token: string) => {
  const formData = new FormData();
  formData.append("school_logo", photo);
  const response = await dashboardApi.put(`/api/v1/core/profile/update`, formData, config(token));
  return response.data;
};

// pricing
export const getProducts = async (token: string, isSchool: boolean) => {
  let params = "/api/v1/core/package";
  // if (isSchool) {
  //   params += "?for_school=true";
  // } else {
  //   params += "?for_teachers=true";
  // }
  const response = await dashboardApi.get(params, config(token));
  return response.data;
};

export const checkoutAction = async (token: string, id: string, promoCode?: string) => {
  // Build URL with optional promo code parameter
  let url = `/api/v1/payment/session/${id}`;
  if (promoCode) {
    url += `?promo_code=${encodeURIComponent(promoCode)}`;
  }
  const response = await dashboardApi.get(url, config(token));
  return response.data;
};

export const applyPackage = async (token: string, packageId: string) => {
  const response = await dashboardApi.post(`/api/v1/core/package/${packageId}`, {}, config(token));
  return response.data;
};
